import React from "react";
import ProductTable from "./components/Table/ProductTable";

const Products = () => {
    return <ProductTable />;
};

export default Products;
